import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import { RelatedFilesModalPropsType } from '@/common/components/modals/relatedFiles/RelatedFilesModal.type.ts';
import { useQuery } from '@tanstack/react-query';
import { relatedFilesQueryOption } from '@/common/queries/relatedFiles/relatedFilesQueryOption.ts';
import CircularLoading from '@/common/components/base/Loading/CircularLoading.tsx';
import { Center } from 'styled-system/jsx';
import MainDetailCard from '@/common/components/DetailCard/MainDetailCard.tsx';
import { css } from 'styled-system/css';
import FileHeader from '@/common/components/DetailCard/headers/fileHeader/FileHeader.tsx';
import DetailCardBody from '@/common/components/DetailCard/DetailCardBody.tsx';
import DetailCardItems from '@/common/components/DetailCard/DetailCardItems.tsx';
import MainModal from '@/common/components/base/modal/Modal.tsx';
import FileListEntryAction from '@/common/components/DetailCard/actions/FileListEntryAction.tsx';

export default ({ id, closeModal, open }: RelatedFilesModalPropsType) => {
  return (
    <MainModal open={open} closeModal={closeModal}>
      <RelatedFiles id={id} />
    </MainModal>
  );
};

const RelatedFiles = ({ id }: Pick<RelatedFilesModalPropsType, 'id'>) => {
  const { data, isPending } = useQuery(relatedFilesQueryOption({ id }));
  if (isPending || !data) {
    return (
      <Center height="300px">
        <CircularLoading color="colors.purple-primary" />
      </Center>
    );
  }
  const { showDetailCardItems, relatedFiles: files } = data;
  return (
    <>
      <TitleDescription>پرونده‌های پیوست</TitleDescription>
      {showDetailCardItems.map((items, index) => (
        <MainDetailCard key={index} className={css({ my: '20px' })}>
          <FileHeader fileType={files[index].file_type.const} />
          <DetailCardBody>
            <DetailCardItems items={items} />
          </DetailCardBody>
          {files[index].has_adjuster ? (
            <FileListEntryAction fileId={files[index].id} />
          ) : null}
        </MainDetailCard>
      ))}
    </>
  );
};
